import { render, staticRenderFns } from "./ColorButton.vue?vue&type=template&id=791c7fca&scoped=true&"
import script from "./ColorButton.vue?vue&type=script&lang=ts&"
export * from "./ColorButton.vue?vue&type=script&lang=ts&"
import style0 from "./ColorButton.vue?vue&type=style&index=0&id=791c7fca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791c7fca",
  null
  
)

export default component.exports